<template>
  <td
    class="table-currency-cell"
    :class="{ credit, empty, debit, invalid, adjusted }"
  >
    {{ string }}
  </td>
</template>
<script>
import TableCellMixin from "./TableCellMixin.js";

export default {
  mixins: [TableCellMixin],
  computed: {
    string() {
      if (isNaN(this.amount)) {
        return "0.00";
      } else {
        return this.amount.toFixed(2);
      }
      // return this.$sdk.utils.formatCurrency(this.amount, this.currency);
    },
    amount() {
      return Number(parseInt(this.value) / 100);
    },
    credit() {
      return this.amount > 0;
    },
    debit() {
      return this.amount < 0;
    },
    invalid() {
      return this.column?.key === "amount" && this.adjusted;
    },
    adjusted() {
      return this.row.effectiveAmount !== this.row.amount;
    },
    empty() {
      return parseInt(this.value) === 0;
    },
    currency() {
      return this.column.currency || this.row.currency;
    },
  },
};
</script>
<style scoped lang="scss">
td {
  text-align: center;

  &.credit {
  }

  &.debit {
    color: red;
  }

  &.empty {
    opacity: 0.3;
  }

  &.invalid {
    text-decoration: line-through;
    opacity: 0.3;
  }
}
</style>
